import API from "@irati/utils/services/API";
import endpoints from "../endpoints";
import codes from "../errorCodes/Login";
var WhoAmI = /** @class */ (function () {
    function WhoAmI() {
    }
    WhoAmI.prototype.isAuthed = function () {
        return API.get(endpoints.validateToken()).then(function () { return true; }).catch(function () {
            var e = new Error();
            e.code = codes.InvalidLoginDetails;
            throw e;
        });
    };
    return WhoAmI;
}());
var whoAmI = new WhoAmI();
export var isAuthed = whoAmI.isAuthed;
export default whoAmI;
